import type { RxJsonSchema } from 'rxdb';
import type { PreviousReportFiles } from './previousReports.types';

export const previousReportFilesSchema: RxJsonSchema<PreviousReportFiles> = {
  type: 'object',
  version: 1,
  description: 'describes work package files',
  primaryKey: 'pkAssetInspection',
  properties: {
    pkAssetInspection: { type: 'string', maxLength: 36 },
    fkAsset: { type: ['number', 'null'] },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    originalPath: { type: ['string', 'null'] },
    inspectionType: { type: ['string', 'null'] },
    assetName: { type: ['string', 'null'] },
    dateCompleted: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};
